"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowTriggerEnum = void 0;
// needed since we can't mix enums and literals down in the other enum
var WorkflowTriggerExtensionEnum;
(function (WorkflowTriggerExtensionEnum) {
    WorkflowTriggerExtensionEnum["AMOUNT"] = "Amount";
})(WorkflowTriggerExtensionEnum || (WorkflowTriggerExtensionEnum = {}));
var WorkflowTriggerEnum;
(function (WorkflowTriggerEnum) {
    WorkflowTriggerEnum["COST_CENTER"] = "CostCenter";
    WorkflowTriggerEnum["VENDOR"] = "Vendor";
    WorkflowTriggerEnum["USER"] = "User";
    WorkflowTriggerEnum["COST_CENTER_2"] = "CostCenter2";
    WorkflowTriggerEnum["AMOUNT"] = "Amount";
})(WorkflowTriggerEnum = exports.WorkflowTriggerEnum || (exports.WorkflowTriggerEnum = {}));
